export const EVENT_TYPE_OPTIONS = [
	{ value: 'AddressChange', label: 'Adressänderung' },
	{ value: 'CapitalChange', label: 'Kapitaländerung' },
	{ value: 'ContractChange', label: 'Vertragsänderung' },
	{ value: 'ControlChange', label: 'Kontrollwechsel' },
	{ value: 'Continuation', label: 'Fortführung' },
	{ value: 'Funding', label: 'Förderung' },
	{ value: 'LegalFormChange', label: 'Rechtsformwechsel' },
	{ value: 'LeiDate', label: 'LEI-Datum' },
	{ value: 'ManagementChange', label: 'Geschäftsführerwechsel' },
	{ value: 'MergerOrAcquisition', label: 'Fusion/Übernahme' },
	{ value: 'NameChange', label: 'Namensänderung' },
	{ value: 'NewCompany', label: 'Neugründung' },
	{ value: 'Patent', label: 'Patent' },
	{ value: 'RegisterChange', label: 'Registeränderung' },
	{ value: 'Restoration', label: 'Wiedereintragung' },
	{ value: 'StatutoryChange', label: 'Satzungsänderung' },
	{ value: 'Trademark', label: 'Marke' },
	{ value: 'YearlyReport', label: 'Jahresbericht' },
];

export const LEGAL_FORM_OPTIONS = [
	{ value: 'GmbH', label: 'GmbH' },
	{ value: 'GmbH & Co. KG', label: 'GmbH & Co. KG' },
	{ value: 'UG', label: 'UG (haftungsbeschränkt)' },
	{ value: 'UG & Co. KG', label: 'UG & Co. KG' },
	{ value: 'AG', label: 'AG' },
	{ value: 'AG & Co. KG', label: 'AG & Co. KG' },
	{ value: 'KG', label: 'KG' },
	{ value: 'OHG', label: 'OHG' },
	{ value: 'e. K.', label: 'e. K. (Einzelkaufmann)' },
	{ value: 'eG', label: 'eG (Genossenschaft)' },
	{ value: 'e. V.', label: 'e. V. (Verein)' },
	{ value: 'eGbR', label: 'eGbR' },
	{ value: 'GbR', label: 'GbR' },
	{ value: 'gGmbH', label: 'gGmbH (gemeinnützig)' },
	{ value: 'gUG', label: 'gUG (gemeinnützig)' },
	{ value: 'KGaA', label: 'KGaA' },
	{ value: 'GmbH & Co. KGaA', label: 'GmbH & Co. KGaA' },
	{ value: 'PartG', label: 'PartG' },
	{ value: 'PartG mbB', label: 'PartG mbB' },
	{ value: 'SE', label: 'SE (Europäische AG)' },
	{ value: 'SE & Co. KG', label: 'SE & Co. KG' },
	{ value: 'Ltd.', label: 'Ltd.' },
	{ value: 'Ltd. & Co. KG', label: 'Ltd. & Co. KG' },
	{ value: 'GmbH & Co. OHG', label: 'GmbH & Co. OHG' },
	{ value: 'EWIV', label: 'EWIV' },
	{ value: 'VVaG', label: 'VVaG' },
	{ value: 'LLP', label: 'LLP' },
];

export const COUNTRY_OPTIONS = [
	{ value: 'Deutschland', label: 'Deutschland' },
	{ value: 'Österreich', label: 'Österreich' },
	{ value: 'Schweiz', label: 'Schweiz' },
	{ value: 'Belgien', label: 'Belgien' },
	{ value: 'Bulgarien', label: 'Bulgarien' },
	{ value: 'Dänemark', label: 'Dänemark' },
	{ value: 'Estland', label: 'Estland' },
	{ value: 'Finnland', label: 'Finnland' },
	{ value: 'Frankreich', label: 'Frankreich' },
	{ value: 'Griechenland', label: 'Griechenland' },
	{ value: 'Irland', label: 'Irland' },
	{ value: 'Italien', label: 'Italien' },
	{ value: 'Kroatien', label: 'Kroatien' },
	{ value: 'Lettland', label: 'Lettland' },
	{ value: 'Litauen', label: 'Litauen' },
	{ value: 'Luxemburg', label: 'Luxemburg' },
	{ value: 'Malta', label: 'Malta' },
	{ value: 'Niederlande', label: 'Niederlande' },
	{ value: 'Polen', label: 'Polen' },
	{ value: 'Portugal', label: 'Portugal' },
	{ value: 'Rumänien', label: 'Rumänien' },
	{ value: 'Schweden', label: 'Schweden' },
	{ value: 'Slowakei', label: 'Slowakei' },
	{ value: 'Slowenien', label: 'Slowenien' },
	{ value: 'Spanien', label: 'Spanien' },
	{ value: 'Tschechien', label: 'Tschechien' },
	{ value: 'Ungarn', label: 'Ungarn' },
	{ value: 'Zypern', label: 'Zypern' },
	{ value: 'USA', label: 'USA' },
	{ value: 'Kanada', label: 'Kanada' },
	{ value: 'China', label: 'China' },
	{ value: 'Indien', label: 'Indien' },
	{ value: 'Brasilien', label: 'Brasilien' },
	{ value: 'Norwegen', label: 'Norwegen' },
];

export const WEBSITE_FILTER_OPTIONS = [
	{ value: 'all', label: 'Alle Firmen' },
	{ value: 'with', label: 'Nur mit Website' },
	{ value: 'without', label: 'Nur ohne Website' },
];
